import { ILayerViewModel, ILayout } from '../models/interfaces';
import { RelocateComposer } from './relocateComposer';

export class TraceSpacingComposer extends RelocateComposer<number> {
    // constructor

    constructor(layout: ILayout) {
        super(layout, 0);
    }

    public isChanged() {
        return true;
    }

    // protected functions

    onUpdate(layer: ILayerViewModel) {
        super.onUpdate(layer);
    }
}
